import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Headers} from '../../global/util/Headers';
import {HttpClient} from '@angular/common/http';
import {Generic} from '../model/Generic';

@Injectable({
  providedIn: 'root'
})
export class ParameterService {

  constructor(private http: HttpClient) {
  }

  public update(url: string, generic: Generic): Observable<any> {
    return this.http.put(url, JSON.stringify(generic), Headers.contentType);
  }
}
